module.exports = __webpack_public_path__ + "img/regProp-2.f2d55e88.jpg";